export class RolePermissions {
//  roleId: number;
  monitor: boolean;
  reports: boolean;
  posCatalog: boolean;
  merchantCatalog: boolean;
  cardBrandCatalog: boolean;
  cardIssuerCatalog: boolean;
  binCatalog: boolean;
  promotions: boolean;
  routing: boolean;
  admin: boolean;
}
